// @flow
export default (input, output) => {
  const inputFile = input.get(0);
  if (inputFile.files && inputFile.files[0]) {
    const reader = new FileReader();
    reader.onload = e => {
      $(output).attr('src', e.target.result);
      $(output).removeClass('d-none');
      $('.image-input').remove();
    };
    reader.readAsDataURL(inputFile.files[0]);
  } else if ($(output).data('default')) {
    $(output).attr('src', $(output).data('default'));
  }
};
